import { useState, useEffect } from 'react';

export const Countdown = ({ showCountdown, from, text, onExpire, children }) => {
  const [enabled, setEnabled] = useState(showCountdown);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    setEnabled(showCountdown);
    setElapsed(0);
  }, [showCountdown]);

  useEffect(() => {
    if (enabled) {
      let ticks = from;
      const interval = setInterval(() => {
        if (--ticks <= 0) {
          setEnabled(false);
          onExpire && onExpire();
        } else {
          setElapsed(x => x + 1);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [enabled, from, onExpire]);

  const enabledInSeconds = Math.max(0, from - elapsed);

  return enabled && enabledInSeconds > 0 ? (
    <div className="text-default-500">{`${text} in ${enabledInSeconds} seconds`}</div>
  ) : (
    children
  );
};
